<div class="bg-white">
  <div class="container mx-auto">
    <div class="flex sm:items-center px-4 py-3">
      <div class="pr-2">
        <a class="text-gray-300" href="javascript:void(0);" [routerLink]="'/knowledge-base/'">
          <i class="fa fa-angle-left font-bold text-3xl"></i>
        </a>
      </div>
      <div class="text-gray-300 font-medium flex-1 text-center text-sm sm:text-base">
        {{ (data && data.knowledgeBaseArticle) ? data.knowledgeBaseArticle.title : "&nbsp;" }}
      </div>
    </div>
  </div>
</div>

<div class="container mx-auto px-4 py-4 min-h-90-vh lg:min-h-70-vh">
  <div class="bg-white p-4 shadow-card">
    @if (data && data.knowledgeBaseArticle) {
      <div class="ck-content clearfix ck-editor-style overflow-auto"
        [innerHTML]="data.knowledgeBaseArticle.content | safeHtml">
      </div>
    }
  </div>
</div>